var map = {
	"./": 320,
	"./Prematch": 1166,
	"./Prematch.tsx": 1166,
	"./PrematchDeferred": 378,
	"./PrematchDeferred.tsx": 378,
	"./PrematchPage": 345,
	"./PrematchPage.dictionary": 346,
	"./PrematchPage.dictionary.json": 346,
	"./PrematchPage.explanation": 1168,
	"./PrematchPage.explanation.ts": 1168,
	"./PrematchPage.tsx": 345,
	"./actions": 47,
	"./actions/": 47,
	"./actions/index": 47,
	"./actions/index.ts": 47,
	"./components/Content": 1029,
	"./components/Content/": 1029,
	"./components/Content/Content": 1001,
	"./components/Content/Content.tsx": 1001,
	"./components/Content/index": 1029,
	"./components/Content/index.ts": 1029,
	"./components/MatchCenter": 916,
	"./components/MatchCenter/": 916,
	"./components/MatchCenter/MatchCenter": 888,
	"./components/MatchCenter/MatchCenter.module.scss": 951,
	"./components/MatchCenter/MatchCenter.tsx": 888,
	"./components/MatchCenter/index": 916,
	"./components/MatchCenter/index.ts": 916,
	"./components/Sport": 917,
	"./components/Sport/": 917,
	"./components/Sport/Sport": 952,
	"./components/Sport/Sport.module.scss": 1167,
	"./components/Sport/Sport.tsx": 952,
	"./components/Sport/Tournaments": 1002,
	"./components/Sport/Tournaments/": 1002,
	"./components/Sport/Tournaments/Grid": 1063,
	"./components/Sport/Tournaments/Grid.js": 1063,
	"./components/Sport/Tournaments/index": 1002,
	"./components/Sport/Tournaments/index.jsx": 1002,
	"./components/Sport/Unions": 1003,
	"./components/Sport/Unions/": 1003,
	"./components/Sport/Unions/Grid": 1005,
	"./components/Sport/Unions/Grid.js": 1005,
	"./components/Sport/Unions/Unions": 1004,
	"./components/Sport/Unions/Unions.tsx": 1004,
	"./components/Sport/Unions/UnionsVirtualizer": 1006,
	"./components/Sport/Unions/UnionsVirtualizer.tsx": 1006,
	"./components/Sport/Unions/Virtualizer": 1007,
	"./components/Sport/Unions/Virtualizer.tsx": 1007,
	"./components/Sport/Unions/index": 1003,
	"./components/Sport/Unions/index.tsx": 1003,
	"./components/Sport/index": 917,
	"./components/Sport/index.ts": 917,
	"./components/SportRedirect": 918,
	"./components/SportRedirect/": 918,
	"./components/SportRedirect/SportRedirect": 889,
	"./components/SportRedirect/SportRedirect.tsx": 889,
	"./components/SportRedirect/index": 918,
	"./components/SportRedirect/index.ts": 918,
	"./components/SportsGrid": 1064,
	"./components/SportsGrid/": 1064,
	"./components/SportsGrid/SportsGrid": 1073,
	"./components/SportsGrid/SportsGrid.module.scss": 1092,
	"./components/SportsGrid/SportsGrid.tsx": 1073,
	"./components/SportsGrid/components/TournamentTable/TournamentTable": 1065,
	"./components/SportsGrid/components/TournamentTable/TournamentTable.js": 1065,
	"./components/SportsGrid/index": 1064,
	"./components/SportsGrid/index.ts": 1064,
	"./index": 320,
	"./index.ts": 320,
	"./reducer": 297,
	"./reducer/": 297,
	"./reducer/entities": 220,
	"./reducer/entities.ts": 220,
	"./reducer/index": 297,
	"./reducer/index.js": 297,
	"./reducer/prematchMatches": 357,
	"./reducer/prematchMatches.js": 357,
	"./reducer/presentation": 221,
	"./reducer/presentation.ts": 221,
	"./selectors/gridEntities": 200,
	"./selectors/gridEntities.ts": 200,
	"./selectors/gridPresentation": 843,
	"./selectors/gridPresentation.ts": 843,
	"./selectors/matchGridEntities": 290,
	"./selectors/matchGridEntities.ts": 290,
	"./selectors/matchGridPresentation": 1062,
	"./selectors/matchGridPresentation.ts": 1062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1283;
module.exports = webpackContext;